<template>
  <div class="content">
    <h1 class="has-text-centered">Gleichstrom</h1>
    <div class="has-text-centered mb-5">
      <div class="field">
        <div class="dropdown is-300px-width" :class="{ 'is-active': dropdown_active }">
          <div class="dropdown-trigger is-300px-width">
            <button class="button is-300px-width" @click="toggleDropdown()">
              <span>Welche Formel suchst du?</span>
              <span class="icon is-small">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu is-300px-width">
            <div class="dropdown-content">
              <a class="dropdown-item is-clickable pl-2 pr-2" v-for="(formula, index) in formulas" :key="index" :href="'#' + formula.title.replace(/\s+/g, '')" @click="toggleDropdown()">
                {{ formula.title }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Formula v-for="(formula, index) in formulas" :key="index" :formula="formula" />

  </div>
</template>

<script>
import Formula from '@/components/Formula.vue'

export default {
  name: 'formulas-dc',
  components: {
    Formula
  },
  metaInfo: {
    title: 'Gleichstrom Formelsammlung | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine Formelsammlung für Gleichstrom Schaltungen.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'formulas' })
  },
  methods: {
    toggleDropdown () {
      if (this.dropdown_active) {
        this.dropdown_active = false
      } else {
        this.dropdown_active = true
      }
    }
  },
  data () {
    return {
      dropdown_active: false,
      formulas: [
        {
          title: 'Stromstärke und elektrische Ladung',
          formulas: [
            {
              content: 'I=\\frac{Q}{t}' // v-katex
            },
            {
              content: 'Q=I*t' // v-katex
            }
          ],
          variables: [
            {
              short: 'I', // v-katex
              description: 'Stromstärke',
              unit: {
                short: 'A', // v-katex
                name: 'Ampere'
              }
            },
            {
              short: 'Q', // v-katex
              description: 'Ladungsmenge/Elektrizitätsmenge',
              unit: {
                short: 'C', // v-katex
                name: 'Coulomb'
              }
            },
            {
              short: 't', // v-katex
              description: 'Zeit',
              unit: {
                short: 's', // v-katex
                name: 'Sekunde'
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Spannung',
          formulas: [
            {
              content: 'U=\\frac{W}{Q}' // v-katex
            },
            {
              content: 'U=\\frac{W}{I*t}' // v-katex
            }
          ],
          variables: [
            {
              short: 'U', // v-katex
              description: 'Spannung',
              unit: {
                short: 'V', // v-katex
                name: 'Volt'
              }
            },
            {
              short: 'W', // v-katex
              description: 'Elektrische Arbeit',
              unit: {
                short: 'J', // v-katex
                name: 'Joule'
              }
            },
            {
              short: 'Q', // v-katex
              description: 'Ladungsmenge/Elektrizitätsmenge',
              unit: {
                short: 'C', // v-katex
                name: 'Coulomb'
              }
            },
            {
              short: 'I', // v-katex
              description: 'Stromstärke',
              unit: {
                short: 'A', // v-katex
                name: 'Ampere'
              }
            },
            {
              short: 't', // v-katex
              description: 'Zeit',
              unit: {
                short: 's', // v-katex
                name: 'Sekunde'
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Ohmsches Gesetz',
          formulas: [
            {
              content: 'U=R*I' // v-katex
            }
          ],
          variables: [
            {
              short: 'U', // v-katex
              description: 'Spannung',
              unit: {
                short: 'V', // v-katex
                name: 'Volt'
              }
            },
            {
              short: 'R', // v-katex
              description: 'Ohmscher Widerstand',
              unit: {
                short: '\\Omega', // v-katex
                name: 'Ohm'
              }
            },
            {
              short: 'I', // v-katex
              description: 'Stromstärke',
              unit: {
                short: 'A', // v-katex
                name: 'Ampere'
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Energie, Arbeit und Leistung',
          formulas: [
            {
              content: 'W=U*I*t' // v-katex
            },
            {
              content: 'W=P*t' // v-katex
            },
            {
              content: 'W=U*Q' // v-katex
            },
            {
              content: 'P=U*I=\\frac{W}{t}' // v-katex
            },
            {
              content: 'P=I^2*R=\\frac{U^2}{R}' // v-katex
            }
          ],
          variables: [
            {
              short: 'W', // v-katex
              description: 'Elektrische Arbeit',
              unit: {
                short: 'J', // v-katex
                name: 'Joule'
              }
            },
            {
              short: 'U', // v-katex
              description: 'Spannung',
              unit: {
                short: 'V', // v-katex
                name: 'Volt'
              }
            },
            {
              short: 'I', // v-katex
              description: 'Stromstärke',
              unit: {
                short: 'A', // v-katex
                name: 'Ampere'
              }
            },
            {
              short: 't', // v-katex
              description: 'Zeit',
              unit: {
                short: 's', // v-katex
                name: 'Sekunde'
              }
            },
            {
              short: 'P', // v-katex
              description: 'Elektrische Leistung',
              unit: {
                short: 'W', // v-katex
                name: 'Watt'
              }
            },
            {
              short: 'Q', // v-katex
              description: 'Ladungsmenge/Elektrizitätsmenge',
              unit: {
                short: 'C', // v-katex
                name: 'Coulomb'
              }
            },
            {
              short: 'R', // v-katex
              description: 'Ohmscher Widerstand',
              unit: {
                short: '\\Omega', // v-katex
                name: 'Ohm'
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Wirkungsgrad',
          formulas: [
            {
              content: '\\eta=\\frac{P_{ab}}{P_{zu}}' // v-katex
            },
            {
              content: 'P_{V}=P_{zu}-P_{ab}' // v-katex
            },
            {
              content: '\\eta_{ges}=\\eta_1*\\eta_2' // v-katex
            }
          ],
          variables: [
            {
              short: 'P_{ab}', // v-katex
              description: 'Abgegebene Leistung',
              unit: {
                short: 'W', // v-katex
                name: 'Watt'
              }
            },
            {
              short: 'P_{zu}', // v-katex
              description: 'Zugeführte Leistung',
              unit: {
                short: 'W', // v-katex
                name: 'Watt'
              }
            },
            {
              short: 'P_{V}', // v-katex
              description: 'Verlustleistung',
              unit: {
                short: 'W', // v-katex
                name: 'Watt'
              }
            },
            {
              short: '\\eta', // v-katex
              description: 'Wirkungsgrad',
              unit: {
                short: '', // v-katex
                name: ''
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Stromdichte',
          formulas: [
            {
              content: 'S=\\frac{I}{A}' // v-katex
            }
          ],
          variables: [
            {
              short: 'S', // v-katex
              description: 'Stromdichte',
              unit: {
                short: '\\frac{A}{mm^2}', // v-katex
                name: ''
              }
            },
            {
              short: 'I', // v-katex
              description: 'Stromstärke',
              unit: {
                short: 'A', // v-katex
                name: 'Ampere'
              }
            },
            {
              short: 'A', // v-katex
              description: 'Querschnitt des Drahtes',
              unit: {
                short: 'mm^2', // v-katex
                name: ''
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Widerstand und Leitwert',
          formulas: [
            {
              content: 'G=\\frac{1}{R}' // v-katex
            },
            {
              content: 'R=\\frac{1}{G}' // v-katex
            }
          ],
          variables: [
            {
              short: 'G', // v-katex
              description: 'Leitwert',
              unit: {
                short: 'S', // v-katex
                name: 'Siemens'
              }
            },
            {
              short: 'R', // v-katex
              description: 'Ohmscher Widerstand',
              unit: {
                short: '\\Omega', // v-katex
                name: 'Ohm'
              }
            }
          ]
        },
        // ==========================================
        {
          title: 'Leiterwiderstand',
          formulas: [
            {
              content: 'R=\\rho*\\frac{l}{A}' // v-katex
            },
            {
              content: 'R=\\frac{l}{\\kappa*A}' // v-katex
            }
          ],
          variables: [
            {
              short: 'R', // v-katex
              description: 'Leiterwiderstand',
              unit: {
                short: '\\Omega', // v-katex
                name: 'Ohm'
              }
            },
            {
              short: 'l', // v-katex
              description: 'Länge des Drahtes',
              unit: {
                short: 'm', // v-katex
                name: 'Meter'
              }
            },
            {
              short: 'A', // v-katex
              description: 'Querschnitt des Drahtes',
              unit: {
                short: 'm^2', // v-katex
                name: ''
              }
            },
            {
              short: '\\rho', // v-katex
              description: 'Spezifischer Widerstand',
              unit: {
                short: '{\\Omega}m', // v-katex
                name: ''
              }
            },
            {
              short: '\\kappa', // v-katex
              description: 'Elektrische Leitfähigkeit',
              unit: {
                short: '\\frac{1}{{\\Omega}m}', // v-katex
                name: ''
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
